export default __webpack_public_path__ + "static/KatarzynaKopeć-21b095d3c692306ba54a51cb8826bcba.png";